"use strict";

import $ from 'jquery';
import { mentionID, articleTitle, authorsIDs, articleID, authorIDtoHTML, disambiguationStatus, mentionContext } from './render';
import { complete_journal_label, load_philosopher_completions, load_author_completions, complete_philosopher_multilabel_search } from './autocomplete_wrappers';
import { interact_flags } from './interactions';

$(function () {
    const queryString = $('#pageSpecificScript').attr('data-queryString');
    $('#dataTable').DataTable({
        "ajax": {
            'url': '/search.json?' + queryString,
            'type': "GET",
        },
        "columns": [
            null, // publicationYear
            { render: articleTitle }, // Journal Standard Name
            { render: articleTitle }, // Article TItle
            { render: articleID },
            {render: mentionContext },
            { render: authorIDtoHTML }, // recognized author
            // {render: articleIDnbsp},
            null, // creator, unsanitized JSTOR string
            { render: authorsIDs },
            { render: disambiguationStatus },
            { render: mentionID },
        ],
    });

    // Auto completion for search fields
    const completions = load_philosopher_completions();
    const author_completions = load_author_completions();
    complete_philosopher_multilabel_search('Mentioned_PSN', completions);
    complete_philosopher_multilabel_search('Mentioning_PSN', author_completions);
    // complete_journal_label(['Journal_Standard_Name']);

    // jQuery interactivity
    interact_flags();
});
